import { useCompassCard } from '@scale/compass-ui/store';
import type { GroupByContext } from '@scale/genai-compass-shared/cards/group_by';
import { Column } from '@scale/compass-shared/types';

const getColumnFromName = (columnName: string, columns: Column[]): Column => {
  const column = columns.filter((column: Column) => column.id === columnName)[0];
  return column;
};

const useGroupByCard = (index: number) => {
  const { card, updateCardCanSubmit, updateCardContext } = useCompassCard(index);
  const { retrievedOutput } = useCompassCard(index - 1);
  const context = card.defaultContext as GroupByContext;
  const columns = retrievedOutput?.response?.schema ?? [];

  const setColumnToGroup = (columnName: string) => {
    updateCardContext({
      ...context,
      columnToGroup: getColumnFromName(columnName, columns),
    } as GroupByContext);
  };

  const setColumnToGroupBy = (columnName: string) => {
    updateCardContext({
      ...context,
      columnToGroupBy: getColumnFromName(columnName, columns),
    } as GroupByContext);
  };

  return {
    card,
    updateCardCanSubmit,
    columnToGroup: context.columnToGroup,
    columnToGroupBy: context.columnToGroupBy,
    setColumnToGroup,
    setColumnToGroupBy,
  };
};

export default useGroupByCard;
